module.exports = __webpack_public_path__ + "img/Stab_OBJ.451a3ae3.svg";